/**
 * Global avatar fallback image path
 * Used throughout the application when profile/avatar images are not available
 */
export const DEFAULT_AVATAR = '/img/user.svg';

/**
 * Helper function to get avatar source with fallback
 * @param {string|null|undefined} imageUrl - The image URL to use
 * @returns {string} - The image URL or fallback avatar
 */
export const getAvatarSrc = (imageUrl) => {
  return imageUrl || DEFAULT_AVATAR;
};

/**
 * Staff schedule / booking avatars: prefer the linked user's account photo (Account Settings),
 * then the schedule-specific headshot upload.
 */
export function getStaffMemberDisplayPhoto(staffMember) {
  if (!staffMember) return null;
  const u = staffMember.user;
  if (u?.profilePicture) return u.profilePicture;
  if (staffMember.profileImage) return staffMember.profileImage;
  if (u?.avatar) return u.avatar;
  return null;
}

